import { Loader } from '@mantine/core'
import { FC, Suspense, useContext, lazy } from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { WithChildren, checkRole } from '../../_metronic/helpers'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import { Toolbar1 } from '../../_metronic/layout/components/toolbar/Toolbar1'
import roleContext from '../context/roleContext'
import { FEATURE_KEYS } from '../features/featureRegistry'
import { useAuth } from '../modules/auth'
import { ForgotPassword } from '../modules/auth/components/ForgotPassword'
import Assets from '../pages/assests/Assets'
import Band from '../pages/band/Band'
import ChangeLog from '../pages/changelog/ChangeLog'
import Configuration from '../pages/configuration/Configuration'
import { DashboardWrapper } from '../pages/dashboard/DashboardWrapper'
import Holiday from '../pages/holiday/Holiday'
import Leave from '../pages/leave/Leave'
import ComposeMail from '../pages/mail/ComposeMail'
import Mail from '../pages/mail/Mail'
import MailLayout from '../pages/mail/MailLayout'
import Organization from '../pages/organization/Organization'
import Overviews from '../pages/organization/project/Overviews'
import ProjectOverview from '../pages/organization/project/ProjectOverview'
import SubTaskOverview from '../pages/organization/task/SubTaskOverview'
import Task from '../pages/organization/task/Task'
import TaskOverview from '../pages/organization/task/TaskOverview'
import Users from '../pages/organization/users/Users'
import Partner from '../pages/partner/Partner'
import Payslip from '../pages/payslip/Payslip'
import Policies from '../pages/policy/Policies'
import Profile from '../pages/profile/Profile'
import Reports from '../pages/reports/Reports'
import Salary from '../pages/salary/Salary'
import SalaryStructure from '../pages/salarystructure/SalaryStructure'
import { RoleContextValue } from '../types/OtherTypes'
import AmsLayout from '../pages/attendance/AmsLayout'
import HiringApplications from '../pages/hiring/HiringApplications'
import JobPostsList from '../pages/hiring/JobPostsList'
import CreateJobPost from '../pages/hiring/CreateJobPost'
import ApplicationDetail from '../pages/hiring/ApplicationDetail'
import Timesheet from '../pages/timesheet/Timesheet'
import MyTimesheet from '../pages/timesheet/MyTimesheet'
import ManagerApproval from '../pages/timesheet/ManagerApproval'
import TimesheetDashboard from '../pages/timesheet/TimesheetDashboard'
import ReportsDashboard from '../pages/timesheet/reports/ReportsDashboard'
import WeekendWorkRequest from '../pages/timesheet/WeekendWorkRequest'
import WeekendWorkApprovals from '../pages/timesheet/WeekendWorkApprovals'
import ImpedimentTracking from '../pages/timesheet/ImpedimentTracking'
//import ShiftManagement from '../pages/ShiftManagement/ShiftManagement'
import ShiftManagement from '../pages/ShiftManagement/ShiftManagement'
import LocationManagement from '../pages/location/LocationManagement'
import AttendanceEditApproval from '../pages/attendance/AttendanceEditApproval'
import DeptMaster from '../pages/Department/DeptMaster'
import Incident from '../pages/incident/Incident'
const PerformanceDashboard = lazy(() => import('../pages/performance/PerformanceDashboard'))
const ReviewCycles = lazy(() => import('../pages/performance/ReviewCycles'))
const ReviewCycleForm = lazy(() => import('../pages/performance/ReviewCycleForm'))
const ReviewCycleView = lazy(() => import('../pages/performance/ReviewCycleView'))
const Goals = lazy(() => import('../pages/performance/Goals'))
const Feedbacks = lazy(() => import('../pages/performance/Feedbacks'))
const Appraisals = lazy(() => import('../pages/performance/Appraisals'))
const FeedbackForm = lazy(() => import('../pages/performance/FeedbackForm'))
const FeedbackView = lazy(() => import('../pages/performance/FeedbackView'))
const AppraisalForm = lazy(() => import('../pages/performance/AppraisalForm'))
const AppraisalView = lazy(() => import('../pages/performance/AppraisalView'))
const EmployeePerformance = lazy(() => import('../pages/performance/EmployeePerformance'))
const GoalForm = lazy(() => import('../pages/performance/GoalForm'))
const GoalView = lazy(() => import('../pages/performance/GoalView'))
const PrivateRoutes = () => {
  let roleState: RoleContextValue = useContext(roleContext)
  const { currentUser } = useAuth()
  const normalizedRoleName =
  roleState.roleName?.trim().toUpperCase().replace(/_/g, ' ')
  const isSuperAdmin = normalizedRoleName === 'SUPER ADMIN'
  const isAdmin = normalizedRoleName === 'ADMIN'
  // const isHr = normalizedRoleName === 'HR' || normalizedRoleName.startsWith('HR ')
  const isRmOrHr = currentUser?.isRmOrHr || false
  const canAccessPerformance = isSuperAdmin || isAdmin || isRmOrHr || normalizedRoleName === 'EMPLOYEE' || checkRole(['performance_management'], roleState.features)
  const canManagePerformance = isSuperAdmin || isAdmin || isRmOrHr
  console.log("Role Name:", roleState.roleName)
  console.log("Features:", roleState.features)
  console.log("Current User:", currentUser)


  // Check if user is a Project Manager (RM or Super Admin)
  //const isProjectManager = currentUser?.isProjectManager || false
  const isProjectManager = currentUser?.isProjectManager || isSuperAdmin || isAdmin
  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* <Route path='auth/*' element={<Navigate to='/dashboard' />} /> */}
        {/* Pages */}
        {/* {checkRole(['dashboard'], roleState.features) && (
          <Route path='dashboard' element={<DashboardWrapper />} />
        )} */}
        {(
          roleState.roleName === 'Super Admin' ||
          roleState.roleName?.toLowerCase() === 'admin' ||
          checkRole(['dashboard'], roleState.features)
        ) && (
          <Route path='dashboard' element={<DashboardWrapper />} />
        )}

        {checkRole(['attendance_management_system'], roleState.features) && (
          <Route path='/attendance' element={<Toolbar1 />} />
        )}
        <Route path='/mail/:id' element={<Mail />} />
        {checkRole(
          ['user_personal_details', 'bank_details', 'deactivate_account'],
          roleState.features
        ) && <Route path='/profile' element={<Profile />} />}
        {checkRole(
          ['users_registration', 'roles', 'designations'],
          roleState.features
        ) && <Route path='/users' element={<Toolbar1 />} />}
        {checkRole(['holidays'], roleState.features) && (
          <Route path='/holidays' element={<Holiday />} />
        )}

        {/* ----------------  SHIFT MANAGEMENT ---------------- */}
        {/* {(currentUser?.isRmOrHr || roleState.roleName === 'Super Admin') && */}
        {/* {(
            currentUser?.isRmOrHr ||
            roleState.roleName === 'Super Admin' ||
            roleState.roleName?.toLowerCase() === 'admin' 
          ) &&
          checkRole(
            ['users_registration', 'roles', 'designations'],
            roleState.features
          ) && (
            <Route
              path='/shift-management'
              element={<ShiftManagement />}
            />
          )} */}
          {(
            isSuperAdmin ||
            (
              (currentUser?.isRmOrHr || isAdmin) &&
              checkRole(
                ['users_registration', 'roles', 'designations'],
                roleState.features
              )
            )
          ) && (
            <Route
              path='/shift-management'
              element={<ShiftManagement />}
            />
          )}

          {/* ----------------  LOCATION MASTER ---------------- */}
          {/* {(currentUser?.isRmOrHr || roleState.roleName === 'Super Admin' || roleState.roleName?.toLowerCase() === 'admin') &&
            checkRole(
              ['users_registration', 'roles', 'designations'],
              roleState.features
            ) && (
              <Route
                path='location-management'
                element={<LocationManagement />}
              />
            )} */}
            {(
              isSuperAdmin ||
              (
                (currentUser?.isRmOrHr || isAdmin) &&
                checkRole(
                  ['users_registration', 'roles', 'designations'],
                  roleState.features
                )
              )
            ) && (
              <Route
                path='/location-management'
                element={<LocationManagement />}
              />
            )}

        {/* Project Management Routes - Only for Project Managers (RM or Super Admin) */}
        {isProjectManager && (
          <Route path='/projects' element={<Organization />} />
        )}
        {isProjectManager && (
          <Route path='/projectOverview/:id' element={<Toolbar1 />}></Route>
        )}
        {isProjectManager && (
          <Route path='/overviews' element={<Overviews />} />
        )}
        {isProjectManager && (
          <Route path='/projectOverview' element={<ProjectOverview />} />
        )}

        {isProjectManager && (
          <Route path='/user' element={<Users />}></Route>
        )}
        {isProjectManager && (
          <Route path='/task' element={<Task />}></Route>
        )}
        {isProjectManager && (
          <Route path='/project/:projectId/taskOverview/:id' element={<TaskOverview />}></Route>
        )}
        {isProjectManager && (
          <Route path='/project/:projectId/subTask/:id' element={<SubTaskOverview />}></Route>
        )}
        {checkRole(
          [
            'user_personal_details',
            'bank_details',
            'deactivate_account',
            'users_registration',
          ],
          roleState.features
        ) && <Route path='/profile/:id' element={<Profile />} />}
        {/* <Route path='/settings' element={<Settings />}></Route> */}
        {checkRole(
          ['leave_config', 'general_config', 'leave_types', 'leave_policies'],
          roleState.features
        ) && <Route path='/setting' element={<Toolbar1 />}></Route>}

        <Route path='/compose' element={<ComposeMail mailId setActiveTab />} />
        <Route path='/changelog' element={<ChangeLog />} />
        {/* {checkRole(['asset_management_system'], roleState.features) && (
          <Route path='/assets' element={<Assets />} />
        )} */}
      
        {/* {checkRole(['Salary'], roleState.features) && ( */}
        <Route path='/salary' element={<Salary />} />
        {/* )} */}
        {/* {checkRole(['Salary Structure'], roleState.features) && ( */}
        <Route path='/salarystructure' element={<SalaryStructure />} />
        {/* )} */}
        {/* {checkRole(['Band'], roleState.features) && ( */}
        <Route path='/band' element={<Band />} />
        <Route path='/configuration' element={<Configuration />} />
        {/* )} */}
        {/* {checkRole(['Payslip'], roleState.features) && ( */}
        <Route path='/payslip' element={<Payslip />} />
        {/* )} */}j
        {/* {checkRole(['reports'], roleState.features) && (
          <Route path='/reports' element={<Reports />} />
        )} */}

        {/* Report also show to admin & Superadmin */}
        {(
          roleState.roleName === 'Super Admin' ||
          roleState.roleName?.toLowerCase() === 'admin' ||
          checkRole(['reports'], roleState.features)
        ) && (
          <Route path='/reports' element={<Reports />} />
        )}

        {/* Hiring Module - Allow for RMs/HRs or users with explicit features */}
        {(currentUser?.isRmOrHr || checkRole([FEATURE_KEYS.hiring_access, FEATURE_KEYS.hiring_view_applications], roleState.features)) && (
          <Route path='/hiring/jobs' element={<JobPostsList />} />
        )}
        {(currentUser?.isRmOrHr || checkRole([FEATURE_KEYS.hiring_create_jd], roleState.features)) && (
          <Route path='/hiring/jobs/new' element={<CreateJobPost />} />
        )}
        {(currentUser?.isRmOrHr || checkRole([FEATURE_KEYS.hiring_view_applications], roleState.features)) && (
          <Route path='/hiring/applications/:id' element={<ApplicationDetail />} />
        )}
        {(currentUser?.isRmOrHr || checkRole([FEATURE_KEYS.hiring_access, FEATURE_KEYS.hiring_view_applications], roleState.features)) && (
          <Route path='/hiring/applications' element={<HiringApplications />} />
        )}
        {checkRole(['leave_management_system', 'leave_audit'], roleState.features) && (
          <Route path='/leave' element={<Leave />} />
        )}
        {/* ================= DEPARTMENT MASTER ================= */}
        {/* {(currentUser?.isRmOrHr || checkRole([FEATURE_KEYS.department_master], roleState.features)) &&
          (
            <Route
              path='/dept-master'
              element={<DeptMaster />}
            />
        )} */}
        {(
          currentUser?.isRmOrHr ||
          roleState.roleName === 'Super Admin' ||
          roleState.roleName?.toLowerCase() === 'admin' ||
          checkRole([FEATURE_KEYS.department_master], roleState.features)
        ) && (
          <Route
            path='/dept-master'
            element={<DeptMaster />}
          />
        )}
        {/* ================= Assets ================= */}
        {(
          roleState.roleName?.toLowerCase() === 'admin' ||
          roleState.roleName === 'Super Admin' ||
          checkRole(['asset_management_system'], roleState.features)
        ) && (
          <Route path='/assets' element={<Assets />} />
        )}

        {/* ================= Incident Management - Accessible to all users ================= */}
        <Route path='/incident' element={<Incident />} />

        {checkRole(['attendance_management_system'], roleState.features) && (
          <Route path='/ams' element={<AmsLayout />} />
        )}

        {/* {checkRole(['attendance_management_system'], roleState.features) &&
          (currentUser?.isRmOrHr || roleState.roleName === 'Super Admin' || roleState.roleName?.toLowerCase() === 'admin') && (
            <Route
              path='/ams/edit-approvals'
              element={<AttendanceEditApproval />}
            />
          )} */}
        {checkRole(['attendance_management_system'], roleState.features) &&
          (currentUser?.isRmOrHr || isSuperAdmin || isAdmin) && (
            <Route
              path='/ams/edit-approvals' element={<AttendanceEditApproval />}
            />
          )}


        {checkRole(['roles'], roleState.features) && (
          <Route path='/roles' element={<Toolbar1 />} />
        )}
        {checkRole(['policies'], roleState.features) && (
          <Route path='/policies' element={<Policies />} />
        )}
        <Route path='/partner' element={<Partner />} />

        {/* Timesheet Dashboard - Accessible to ALL users */}
        <Route path='/timesheet/dashboard' element={<TimesheetDashboard />} />
        {/* {checkRole([FEATURE_KEYS.timesheet_impediments], roleState.features) && (
          <Route path='/timesheet/impediments' element={<ImpedimentTracking />} />
        )} */}
        {(checkRole([FEATURE_KEYS.timesheet_impediments], roleState.features) ||
          currentUser?.isRmOrHr ||
          roleState.roleName?.toLowerCase() === 'admin'||
          roleState.roleName === 'Super Admin') && (
            <Route path='/timesheet/impediments' element={<ImpedimentTracking />} />
        )}

        {(checkRole([FEATURE_KEYS.timesheet_master_data], roleState.features) ||
          currentUser?.isRmOrHr ||
          roleState.roleName?.toLowerCase() === 'admin'||
          roleState.roleName === 'Super Admin') && (
          <Route path='/timesheet/master-data' element={<Timesheet />} />
        )}
        {/* My Timesheet - Accessible to ALL users */}
        <Route path='/my-timesheet' element={<MyTimesheet />} />

        {/* Team Approval */}
        {/* {checkRole([FEATURE_KEYS.timesheet_approve], roleState.features) && (
          <Route path='/timesheet/approvals' element={<ManagerApproval />} />
        )} */}
        {(checkRole([FEATURE_KEYS.timesheet_approve], roleState.features) ||
          currentUser?.isRmOrHr ||
          roleState.roleName?.toLowerCase() === 'admin'||
          roleState.roleName === 'Super Admin') && (
            <Route path='/timesheet/approvals' element={<ManagerApproval />} />
          )}

        {/* Report Dashboard */}
        {/* {checkRole([FEATURE_KEYS.timesheet_reports], roleState.features) && (
          <Route path='/timesheet/reports' element={<ReportsDashboard />} />
        )} */}

        {(checkRole([FEATURE_KEYS.timesheet_reports], roleState.features) ||
          currentUser?.isRmOrHr ||
          roleState.roleName?.toLowerCase() === 'admin'||
          roleState.roleName === 'Super Admin') && (
            <Route path='/timesheet/reports' element={<ReportsDashboard />} />
          )}

        {/* Weekend Work (Request) - Accessible to ALL users */}
        <Route path='/timesheet/weekend-work' element={<WeekendWorkRequest />} />

        {/* Weekend Work Approvals */}
        {/* {checkRole([FEATURE_KEYS.timesheet_weekend_approve], roleState.features) && (
          <Route path='/timesheet/weekend-work/approvals' element={<WeekendWorkApprovals />} />
        )} */}
        {(checkRole([FEATURE_KEYS.timesheet_weekend_approve], roleState.features) ||
          currentUser?.isRmOrHr ||
          roleState.roleName?.toLowerCase() === 'admin'||
          roleState.roleName === 'Super Admin') && (
            <Route path='/timesheet/weekend-work/approvals' element={<WeekendWorkApprovals />} />
          )}


        {/* Lazy Modules */}
        {/* <Route
          path='crafted/pages/profile/*'
          element={
            <SuspensedView>
              <ProfilePage />
            </SuspensedView>
          }
        /> */}
        {/* <Route
          path='/attendance'
          element={
            <SuspensedView>
              <Attendance />
            </SuspensedView>
          }
        /> */}
        <Route
          path='/emails'
          element={
            <SuspensedView>
              <MailLayout />
            </SuspensedView>
          }
        />

        <Route
          path='/forgotpassword'
          element={
            <SuspensedView>
              <ForgotPassword />
            </SuspensedView>
          }
        />

        <Route
          path='/profile'
          element={
            <SuspensedView>
              <Profile />
            </SuspensedView>
          }
        />

        <Route
          path='/mail'
          element={
            <SuspensedView>
              <Mail />
            </SuspensedView>
          }
        />
        <Route
          path='/payslip'
          element={
            <SuspensedView>
              <Payslip />
            </SuspensedView>
          }
        />

        {/* <Route
          path='/salary'
          element={
            <SuspensedView>
              <Salary />
            </SuspensedView>
          }
        />   */}
        <Route
          path='/salarystructure'
          element={
            <SuspensedView>
              <SalaryStructure />
            </SuspensedView>
          }
        />

        {/* Performance Module Routes */}
        {(
          canAccessPerformance
        ) && (
          <>
            <Route path='/performance' element={canManagePerformance ? <SuspensedView><PerformanceDashboard /></SuspensedView> : <Navigate to='/performance/goals' replace />} />
            {canManagePerformance && <>
              <Route path='/performance/review-cycles' element={<SuspensedView><ReviewCycles /></SuspensedView>} />
              <Route path='/performance/review-cycles/new' element={<SuspensedView><ReviewCycleForm /></SuspensedView>} />
              <Route path='/performance/review-cycles/:id' element={<SuspensedView><ReviewCycleView /></SuspensedView>} />
              <Route path='/performance/review-cycles/:id/edit' element={<SuspensedView><ReviewCycleForm /></SuspensedView>} />
            </>}
            <Route path='/performance/goals' element={<SuspensedView><Goals /></SuspensedView>} />
            <Route path='/performance/goals/new' element={<SuspensedView><GoalForm /></SuspensedView>} />
            <Route path='/performance/goals/:id' element={<SuspensedView><GoalView /></SuspensedView>} />
            <Route path='/performance/goals/:id/edit' element={<SuspensedView><GoalForm /></SuspensedView>} />
            <Route path='/performance/feedback' element={<SuspensedView><Feedbacks /></SuspensedView>} />
            <Route path='/performance/feedback/new' element={<SuspensedView><FeedbackForm /></SuspensedView>} />
            <Route path='/performance/feedback/:id' element={<SuspensedView><FeedbackView /></SuspensedView>} />
            <Route path='/performance/feedback/:id/edit' element={<SuspensedView><FeedbackForm /></SuspensedView>} />
            <Route path='/performance/appraisals' element={<SuspensedView><Appraisals /></SuspensedView>} />
            <Route path='/performance/appraisals/new' element={<SuspensedView><AppraisalForm /></SuspensedView>} />
            <Route path='/performance/appraisals/:id' element={<SuspensedView><AppraisalView /></SuspensedView>} />
            <Route path='/performance/appraisals/:id/edit' element={<SuspensedView><AppraisalForm /></SuspensedView>} />
            <Route path='/performance/employee/:employeeId/cycle/:reviewCycleId' element={<SuspensedView><EmployeePerformance /></SuspensedView>} />
          </>
        )}

        {/* Default redirect - always prefer dashboard */}
        <Route
          path='/'
          element={
            (
              roleState.roleName === 'Super Admin' ||
              roleState.roleName?.toLowerCase() === 'admin' ||
              checkRole(['dashboard'], roleState.features)
            )
             ? (
              <Navigate to='/dashboard' replace />
            ) : checkRole(['attendance_management_system'], roleState.features) ? (
              <Navigate to='/ams' replace />
            ) : checkRole(['leave_management_system'], roleState.features) ? (
              <Navigate to='/leave' replace />
            ) : (
              // Force redirect to dashboard even if user doesn't have explicit permission
              <Navigate to='/dashboard' replace />
            )
          }
        />

        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  return <Suspense fallback={<Loader />}>{children}</Suspense>
}

export { PrivateRoutes }
